import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import router from './router/router.js'
import i18n from './i18n'
import scUtil from '../static/scUtil.js';
import axios from 'axios';
import VueAxios from 'vue-axios'
import { Message,MessageBox } from "element-ui";
import 'element-ui/lib/theme-chalk/index.css'


Vue.prototype.$scUtil=scUtil;
Vue.use(VueRouter);
// Vue.use(Message);

Vue.component(Message)
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm
Vue.use(VueAxios,axios);
Vue.config.productionTip = false



new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
